import '@/styles/globals.css';

import { renderClientSignIn } from '@/helpers';

document.addEventListener('DOMContentLoaded', () => {
  renderClientSignIn();
});
